export default {"src":"/_next/static/media/rank_2.2ca73d18.gif","height":400,"width":700,"blurWidth":0,"blurHeight":0};